import clsx from 'clsx'
import './styles.scss'

export default function CrossButton({
	className,
	onClick,
}) {
	return <button className={clsx('cross-button', className)} type='button' onClick={onClick}>
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1 17L17 1M1 1L17 17" stroke="#1B1B1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	</button>
}
